<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M5.346,13.333a2.678,2.678,0,0,1-2.579-1.972H.669A.669.669,0,0,1,0,10.693V9.356A2.01,2.01,0,0,1,1.337,7.472V5.346A4,4,0,0,1,4.678,1.4V.669a.668.668,0,1,1,1.337,0V1.4A4,4,0,0,1,9.356,5.346V7.472a2.009,2.009,0,0,1,1.337,1.885v1.337a.669.669,0,0,1-.668.669h-2.1A2.68,2.68,0,0,1,5.346,13.333ZM4.2,11.362a1.323,1.323,0,0,0,2.3,0ZM2.005,8.688a.669.669,0,0,0-.669.668v.669h8.02V9.356a.669.669,0,0,0-.668-.668ZM5.346,2.673A2.676,2.676,0,0,0,2.673,5.346V7.352H8.02V5.346A2.676,2.676,0,0,0,5.346,2.673Z"
        transform="translate(2.654 1.333)"
        fill="#74788d"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBell',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>